import PropTypes from 'prop-types';

// material-ui
import { Chip, Stack } from '@mui/material';

function chipLabel({ marker, title, page }) {
    const pageLabel = page ? `, p. ${page}` : '';
    return `[${marker}] ${title}${pageLabel}`;
}

// One chip per document the answer cites. Opens the document in Drive, where staff
// already have view access; Drive has no page deep link, so the page is text only.
const CitationChips = ({ citations }) => {
    if (citations.length === 0) {
        return null;
    }
    return (
        <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 1 }} data-testid="ask-jivan-citations">
            {citations.map((citation) => (
                <Chip
                    key={citation.marker}
                    size="small"
                    variant="outlined"
                    color="primary"
                    label={chipLabel(citation)}
                    clickable={!!citation.url}
                    component={citation.url ? 'a' : 'div'}
                    href={citation.url || undefined}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ maxWidth: '100%' }}
                />
            ))}
        </Stack>
    );
};

CitationChips.propTypes = {
    citations: PropTypes.arrayOf(
        PropTypes.shape({
            marker: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            url: PropTypes.string,
            page: PropTypes.number
        })
    ).isRequired
};

export default CitationChips;
